import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export default function Logout() {
  useEffect(() => {
    try {
      localStorage.removeItem('maskan_auth');
      localStorage.removeItem('maskan_auth_v2');
    } catch (_) {}
  }, []);
  return <Navigate to="/login" replace />;
}
